import { companyQueryOptions } from '@/hooks/queries/company.queries';
import { ListCompaniesParams } from '@/types/dto/ListCompaniesParams.dto';
import { useQuery } from '@tanstack/react-query';

export function useCompaniesList(params: ListCompaniesParams) {
  const { data, isError, isFetching, isLoading, refetch } = useQuery(companyQueryOptions.list(params));

  return {
    companies: data?.data ?? [],
    isError,
    isFetching,
    isLoading,
    pagination: data?.pagination,
    refetch,
  };
}
